export default __webpack_public_path__ + "static/media/chooose-black.2085b02c.svg";